export default __webpack_public_path__ + "static/media/Gotham-Regular.ec261687.otf";